export default __webpack_public_path__ + "static/studio-3-e61b0d334dca9a79cfff01e5721849a4.jpg";